import { render, staticRenderFns } from "./FinishRegistration.vue?vue&type=template&id=26109bce&scoped=true&"
import script from "./FinishRegistration.vue?vue&type=script&lang=js&"
export * from "./FinishRegistration.vue?vue&type=script&lang=js&"
import style0 from "./FinishRegistration.vue?vue&type=style&index=0&id=26109bce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26109bce",
  null
  
)

export default component.exports